import classNames from 'classnames'
import CheckOutlined from '@ant-design/icons/CheckOutlined'
import React from 'react'
import { EmptyFunction } from '../utils/functions'
import ImageWithBasePath from './ImageWithBasePath'

type CheckBoxProps = {
  className?: string
  onClick?: () => void
  isClicked?: boolean
  disabled?: boolean
  noDash?: boolean
  clickClassName?: string
  unClickClassName?: string
}

export const CheckBoxButton = ({
  onClick = EmptyFunction,
  className = '',
  isClicked = false,
  disabled = false,
  noDash = true,
  clickClassName = 'border-none bg-secondary active:bg-[#66676B]',
  unClickClassName = 'active:bg-secondary'
}: CheckBoxProps) => {
  return (
    <div
      id="check_box"
      className={classNames(
        'flex h-[18px] w-[18px] cursor-pointer items-center justify-center border-sm border-solid border-lightGray',
        className,
        isClicked ? clickClassName : unClickClassName,
        disabled ? 'border-none' : '',
        !noDash && disabled && 'bg-transparent'
      )}
      onClick={disabled ? EmptyFunction : onClick}
    >
      {((isClicked && !disabled) || noDash) && (
        <CheckOutlined className=" text-[12px] text-white" rev={undefined} />
      )}
      {disabled && !noDash && (
        <ImageWithBasePath src="indeterminateCheckbox" height={24} width={24} alt="checkbox" />
      )}
    </div>
  )
}
